import React, { useState } from 'react'

const CourseSchedule = (project) => {
  const [openItems, setOpenItems] = useState({})

  const toggleOpen = (index) => {
    setOpenItems((prevOpenItems) => ({
      ...prevOpenItems,
      [index]: !prevOpenItems[index],
    }))
  }

  return (
    <ul className="scheme-list">
      {project?.project?.schemeList?.map((item, index) => (
        <li key={index} className="scheme-list-box">
          <h2
            className="scheme-tit"
            onClick={() => toggleOpen(index)}
            style={{ cursor: 'pointer' }}
          >
            {item.title}
          </h2>
          {openItems[index] &&
            item?.points?.map((point, pointIndex) => (
              <p
                key={pointIndex}
                className="scheme-txt"
                dangerouslySetInnerHTML={{ __html: point }}
              >
              </p>
            ))}
        </li>
      ))}
    </ul>
  )
}

export default CourseSchedule
